import { render, staticRenderFns } from "./PersonalInfoComp.vue?vue&type=template&id=6f3d1d9a"
import script from "./PersonalInfoComp.vue?vue&type=script&lang=js"
export * from "./PersonalInfoComp.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfoComp.vue?vue&type=style&index=0&id=6f3d1d9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports